export const Themes = {
  POINT: 'point-ds',
  POINT_DARK: 'point-ds-dark',
  DARK: 'dark-mode',
  LIGHT: 'light-mode'
};

// id of the <body> that PointThemeVars writes the Point tokens onto. It has to be <body> and not
// the app root so portaled content (MUI dialogs, tooltips) can resolve the same custom properties.
export const POINT_VARS_TARGET_ID = 'point-ds-vars';
